(function () {
  var GRACE_MS = 500;
  var CURTAIN_MS = 350;
  var ENTER_DELAY_MS = 200;
  var DESKTOP_MQ = "(min-width: 1380px)";
  var SCROLL_DELTA = 2;

  var wrapper = document.querySelector(".site-header-wrapper");
  var header = document.querySelector(".site-header--unified");
  var overlayHeader = document.querySelector(".site-header--overlay");
  var utility = document.querySelector(".utility-bar");

  if (wrapper && overlayHeader && utility && "IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        wrapper.classList.toggle("header-is-stuck", !entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(utility);
  }

  if (!header || !wrapper) return;

  header.setAttribute("data-header-shell", "true");

  (function initScrollHide() {
    var lastY = window.scrollY || window.pageYOffset || 0;
    var ticking = false;
    var menuToggle = header.querySelector("[data-menu-toggle]");
    var hidden = false;
    var applying = false;
    var hideThreshold = 0;

    function refreshHideThreshold() {
      hideThreshold = Math.round(wrapper.offsetTop + wrapper.offsetHeight);
    }

    function isLockedVisible() {
      if (wrapper.classList.contains("header-menu-engaged")) return true;
      if (header.classList.contains("header-menu-engaged")) return true;
      if (menuToggle && menuToggle.classList.contains("active")) return true;
      if (header.classList.contains("site-header-search--open")) return true;
      return false;
    }

    function applyHiddenState() {
      if (applying) return;
      applying = true;

      var locked = isLockedVisible();
      var shouldHide = !locked && hidden;

      if (locked) {
        wrapper.classList.add("header-nav-open");
      } else {
        wrapper.classList.remove("header-nav-open");
      }

      if (shouldHide) {
        wrapper.classList.add("header-is-hidden");
      } else {
        wrapper.classList.remove("header-is-hidden");
      }

      applying = false;
    }

    function setHidden(next) {
      hidden = !!next;
      applyHiddenState();
    }

    function update() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset || 0;

      if (y <= 0) {
        setHidden(false);
        lastY = 0;
        return;
      }

      if (isLockedVisible()) {
        setHidden(false);
        lastY = y;
        return;
      }

      if (y > lastY + SCROLL_DELTA && y >= hideThreshold) {
        setHidden(true);
      } else if (y < lastY) {
        setHidden(false);
      }

      lastY = y;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    refreshHideThreshold();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", refreshHideThreshold, { passive: true });

    if ("MutationObserver" in window) {
      var mo = new MutationObserver(function () {
        if (applying) return;
        applyHiddenState();
      });
      mo.observe(header, { attributes: true, attributeFilter: ["class"] });
      if (menuToggle) {
        mo.observe(menuToggle, { attributes: true, attributeFilter: ["class"] });
      }
    }

    setHidden(false);
  })();

  function initMenuPolish() {
    if (window.matchMedia && !window.matchMedia(DESKTOP_MQ).matches) return;

    var nav = header.querySelector(".site-navigation > .navmenu[data-navmenu]");
    if (!nav) return;

    var parents = [];
    var openParent = null;
    var closingParent = null;
    var switchedDirectly = false;
    var overHeader = false;
    var solidSince = 0;
    var closeTimer;
    var openTimer;
    var closeAnimTimer;
    var pendingParent = null;
    var lastX = -1;
    var lastY = -1;
    var tracking = false;
    var scrim = null;

    function stealParent(listitem) {
      var link = listitem.querySelector(":scope > a.navmenu-link-parent");
      var submenu = listitem.querySelector(":scope > [data-navmenu-submenu]");
      if (!link || !submenu) return null;

      var clone = listitem.cloneNode(false);
      while (listitem.firstChild) {
        clone.appendChild(listitem.firstChild);
      }
      if (listitem.parentNode) {
        listitem.parentNode.replaceChild(clone, listitem);
      }

      return {
        listitem: clone,
        link: clone.querySelector(":scope > a.navmenu-link-parent"),
        submenu: clone.querySelector(":scope > [data-navmenu-submenu]"),
      };
    }

    Array.prototype.forEach.call(
      nav.querySelectorAll(":scope > .navmenu-item-parent"),
      function (listitem) {
        var stolen = stealParent(listitem);
        if (stolen) parents.push(stolen);
      }
    );

    if (!parents.length) return;

    function ensureScrim() {
      if (scrim) return scrim;
      scrim = document.createElement("div");
      scrim.className = "header-menu-scrim";
      scrim.setAttribute("data-menu-overlay", "true");
      scrim.setAttribute("aria-hidden", "true");
      wrapper.appendChild(scrim);
      return scrim;
    }

    function setEngaged(next) {
      var on = !!next;
      header.classList.toggle("header-menu-engaged", on);
      header.setAttribute("data-solid", on ? "true" : "false");
      wrapper.classList.toggle("header-menu-engaged", on);
    }

    function syncEngaged() {
      setEngaged(overHeader || openParent !== null || closingParent !== null);
    }

    function setScrim(open, graceful) {
      var el = ensureScrim();
      el.classList.toggle("is-visible", open);
      el.classList.toggle("is-graceful", !open && graceful);
      if (open || graceful) {
        el.style.transition = "opacity " + CURTAIN_MS + "ms ease-out";
      } else {
        el.style.transition = "none";
      }
      el.style.opacity = open ? "1" : "0";
      el.style.pointerEvents = open ? "auto" : "none";
    }

    function positionMeganav(submenu) {
      if (!submenu.classList.contains("navmenu-meganav")) return;
      submenu.style.left = "";
      var rect = submenu.getBoundingClientRect();
      if (rect.left > 0) {
        submenu.style.left = "-" + rect.left + "px";
      }
    }

    function clearClosing(parent) {
      if (!parent) return;
      parent.listitem.classList.remove("menu-closing");
      parent.submenu.classList.remove("animating-out");
      parent.submenu.style.animation = "";
    }

    function cancelGracefulClose() {
      if (closeAnimTimer !== undefined) {
        clearTimeout(closeAnimTimer);
        closeAnimTimer = undefined;
      }
      if (closingParent) {
        clearClosing(closingParent);
        closingParent = null;
      }
    }

    function cancelClose() {
      if (closeTimer === undefined) return;
      clearTimeout(closeTimer);
      closeTimer = undefined;
    }

    function cancelOpen() {
      if (openTimer === undefined) return;
      clearTimeout(openTimer);
      openTimer = undefined;
      pendingParent = null;
    }

    function closeParent(parent, graceful) {
      if (!parent) return;
      parent.listitem.classList.remove("open");
      parent.listitem.classList.remove("alternate-drop");
      parent.link.setAttribute("aria-expanded", "false");
      parent.submenu.classList.remove("animating-in");
      parent.submenu.style.animation = "";

      if (graceful) {
        parent.listitem.classList.add("menu-closing");
        parent.submenu.classList.add("animating-out");
        parent.submenu.style.animation =
          "hm-curtain-close " + CURTAIN_MS + "ms ease-out both";
        closingParent = parent;
        closeAnimTimer = setTimeout(function () {
          closeAnimTimer = undefined;
          clearClosing(parent);
          if (closingParent === parent) closingParent = null;
          syncEngaged();
          setScrim(false, false);
        }, CURTAIN_MS);
      } else {
        parent.submenu.classList.remove("animating-out");
      }
    }

    function openParentNow(parent) {
      cancelClose();
      cancelGracefulClose();

      if (openParent === parent) return;

      switchedDirectly = openParent !== null;
      if (openParent && openParent !== parent) {
        closeParent(openParent, false);
      }

      openParent = parent;
      parent.listitem.classList.add("open");
      parent.link.setAttribute("aria-expanded", "true");
      parent.submenu.classList.remove("animating-out");
      parent.submenu.classList.add("animating-in");

      if (switchedDirectly) {
        parent.submenu.style.animation = "none";
      } else {
        parent.submenu.style.animation =
          "hm-curtain " + CURTAIN_MS + "ms ease-out both";
      }

      if (!parent.submenu.classList.contains("navmenu-meganav")) {
        var bounds = parent.submenu.getBoundingClientRect();
        if (bounds.right > document.documentElement.clientWidth) {
          parent.listitem.classList.add("alternate-drop");
        }
      } else {
        positionMeganav(parent.submenu);
      }

      syncEngaged();
      setScrim(true, false);
    }

    function requestOpen(parent, delayMs) {
      cancelClose();
      if (delayMs <= 0) {
        cancelOpen();
        openParentNow(parent);
        return;
      }
      if (pendingParent === parent) return;
      cancelOpen();
      pendingParent = parent;
      openTimer = setTimeout(function () {
        openTimer = undefined;
        pendingParent = null;
        openParentNow(parent);
      }, delayMs);
    }

    function closeNow() {
      cancelOpen();
      cancelClose();
      cancelGracefulClose();
      if (openParent) {
        closeParent(openParent, false);
        openParent = null;
      }
      setScrim(false, false);
      syncEngaged();
    }

    function scheduleClose() {
      cancelClose();
      closeTimer = setTimeout(function () {
        closeTimer = undefined;
        var closing = openParent;
        openParent = null;
        if (closing) {
          closeParent(closing, true);
          setScrim(false, true);
        }
        syncEngaged();
      }, GRACE_MS);
    }

    function resolveParentAt(target) {
      if (!(target instanceof Element)) return undefined;
      for (var i = 0; i < parents.length; i++) {
        if (parents[i].listitem.contains(target)) return parents[i];
      }
      return null;
    }

    function setOverHeader(next) {
      if (overHeader === next) return;
      if (next && openParent === null) solidSince = Date.now();
      overHeader = next;
      syncEngaged();
    }

    function onPointerMove(event) {
      lastX = event.clientX;
      lastY = event.clientY;
      var el = event.target instanceof Element ? event.target : null;
      var nowOverHeader = !!(el && el.closest("[data-header-shell]"));
      setOverHeader(nowOverHeader);

      var parent = resolveParentAt(event.target);
      if (parent === undefined) return;

      if (parent === null) {
        if (openParent === null && pendingParent === null) return;
        if (nowOverHeader) {
          cancelOpen();
          scheduleClose();
        } else {
          closeNow();
        }
        return;
      }

      var remaining = ENTER_DELAY_MS - (Date.now() - solidSince);
      requestOpen(parent, openParent !== null ? 0 : Math.max(0, remaining));
    }

    function leftWindow() {
      if (lastX >= 0) {
        var under = document.elementFromPoint(lastX, lastY);
        if (under && under.closest("[data-header-shell]")) return;
      }
      setOverHeader(false);
      if (openParent !== null) closeNow();
    }

    function startTracking() {
      if (tracking) return;
      tracking = true;
      document.addEventListener("pointermove", onPointerMove, { passive: true });
      document.addEventListener("pointerleave", leftWindow);
      document.addEventListener("mouseleave", leftWindow);
    }

    parents.forEach(function (parent) {
      parent.listitem.addEventListener("pointerenter", function () {
        var remaining = ENTER_DELAY_MS - (Date.now() - solidSince);
        requestOpen(parent, openParent !== null ? 0 : Math.max(0, remaining));
      });
      parent.submenu.addEventListener("pointerenter", function () {
        cancelClose();
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && openParent) {
        openParent.link.focus();
        closeNow();
      }
    });

    ensureScrim().addEventListener("click", closeNow);
    header.setAttribute("data-menu-polish", "true");
    startTracking();
  }

  function bootMenuPolish() {
    if (header.getAttribute("data-menu-polish") === "true") return;
    if (window.matchMedia && !window.matchMedia(DESKTOP_MQ).matches) return;
    initMenuPolish();
  }

  function scheduleBoot() {
    setTimeout(bootMenuPolish, 100);
  }

  if (document.readyState === "complete") {
    scheduleBoot();
  } else {
    window.addEventListener("load", scheduleBoot);
  }
})();
